const mobOpenCloseBtns = document.querySelectorAll('.b-filter-sort-mob-btn')

// const mobOpenCloseBtnActive = document.querySelector('.b-filter-sort-mob-btn--active')


const checkboxTitles = document.querySelectorAll('.b-filter-title')
const checkboxes = document.querySelectorAll('.b-filter-checkboxes')




if (mobOpenCloseBtns) {

  mobOpenCloseBtns.forEach(mobOpenCloseBtn => {

    const filterForm = mobOpenCloseBtn.nextElementSibling

    mobOpenCloseBtn.addEventListener('click', () => {

      if (mobOpenCloseBtn.classList.contains('b-filter-sort-mob-btn--active')) {

        mobOpenCloseBtn.classList.remove('b-filter-sort-mob-btn--active')



        filterForm.classList.remove('b-filter-sort-form--show')
        filterForm.classList.add('b-filter-sort-form--hide')

        checkboxTitles.forEach(checkboxTitle => {
          checkboxTitle.classList.remove('b-filter-title--active')
        });


        checkboxes.forEach(checkbox => {
          checkbox.style.maxHeight = "0px"
          checkbox.classList.remove('b-filter-checkboxes--show')
        });



      } else {
        mobOpenCloseBtn.classList.add('b-filter-sort-mob-btn--active')
        filterForm.classList.remove('b-filter-sort-form--hide')
        filterForm.classList.add('b-filter-sort-form--show')


        checkboxes.forEach(checkbox => {
          checkbox.style.maxHeight = contentHeight
          checkbox.classList.remove('b-filter-checkboxes--hide')
          checkbox.classList.add('b-filter-checkboxes--show')
        });

      }

    })
  });


}


if (checkboxTitles) {
  checkboxTitles.forEach(checkboxTitle => {
    checkboxTitle.addEventListener('click', function () {

      if (this.classList.contains('b-filter-title--active')) {
        this.classList.remove('b-filter-title--active')
        this.classList.add('b-filter-title--not-active')
      } else {
        this.classList.remove('b-filter-title--not-active')
        this.classList.add('b-filter-title--active')

      }

      const content = this.nextElementSibling
      const contentHeight = content.scrollHeight + "px"

      if (content.classList.contains('b-filter-checkboxes--show')) {

        this.nextElementSibling.style.maxHeight = "0px"
        this.nextElementSibling.classList.remove('b-filter-checkboxes--show')
        this.nextElementSibling.classList.add('b-filter-checkboxes--hide')

        const inputs = this.nextElementSibling.querySelectorAll('input')
        inputs.forEach(input => {
          input.style.display = "none"
        });


      } else {
        this.nextElementSibling.style.maxHeight = contentHeight
        this.nextElementSibling.classList.remove('b-filter-checkboxes--hide')
        this.nextElementSibling.classList.add('b-filter-checkboxes--show')
        const inputs = this.nextElementSibling.querySelectorAll('input')
        inputs.forEach(input => {
          input.style.display = "block"
        });


      }
    })
  });

}
